import React from "react";


import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import CreateNewDesign from "./components/userForms/CreateNewDesign";
import CreativeCreateDesign from "./components/userForms/CreativeCreateDesignForm";
import MyAccount from "./components/userForms/MyAccount";

import Landing from "./pages/Landing/Landing";
import CreativeHome from "./pages/Home/CreativeHome";
import AdminDashboard from "./pages/AdminDashboard/index";
import ClientHome from "./pages/Home/ClientHome";

import ChooseYourDesign from "./pages/Home/ChooseYourDesign";
import CreativeChooseYourDesign from "./pages/Home/CreativeChooseYourDesign";

import SkiContents from "./pages/SkiContents/SkiContents";
import ResetPassword from "./components/userForms/ResetPassword";
import BusinessCategory from "./components/ForPages/BusinessCategory";
import EmailConfirmed from "./pages/EmailConfirmed";
import Notfound from "./pages/Notfound";
import ViewAll from "./components/userForms/ViewAll";

function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route path="/" exact component={Landing} />
          <Route path="/admin-dashboard" exact component={AdminDashboard} />
          <Route path="/business-category" exact component={BusinessCategory} />

          <Route path="/creative-home" exact component={CreativeHome} />
          <Route
            path="/creative-home/choose-your-design"
            exact
            component={CreativeChooseYourDesign}
          />

          <Route path="/client-home" exact component={ClientHome} />
          <Route
            path="/client-home/choose-your-design"
            exact
            component={ChooseYourDesign}
          />
          <Route
          path="/client-home/choose-your-design/view-all"
          exact component={ViewAll}
          />

          <Route path="/ski-contents" exact component={SkiContents} />
          <Route path="/account" exact component={MyAccount} />
          <Route path="/create-design" exact component={CreateNewDesign} />

          <Route
            path="/reset-password/:id/:token"
            exact
            component={ResetPassword}
          />
          <Route
            path="/email-confirmed/:uid"
            exact
            component={EmailConfirmed}
          />
          <Route
            path="/creative-create-design"
            exact
            component={CreativeCreateDesign}
          />
          <Route>
            <Notfound />
          </Route>
        </Switch>
      </Router>
    </>
  );
}

export default App;
